import React from 'react';
import { AddressInputType } from '@domain/addresses/types/types';
import { Dimensions, StyleSheet, View } from 'react-native';
import { MapMarker } from '@usepepper/ui/molecules/map/map-marker';
import { StaticMapView } from '@usepepper/ui/molecules/map/static-map-view';
import { useLayoutContext } from '@/contexts/layout-context';

interface Props {
  address: AddressInputType;
}

export const AccountDetailsMap: React.FC<Props> = ({ address }) => {
  const { isSmallLayout } = useLayoutContext();

  const coordinate = {
    latitude: address.latitude,
    longitude: address.longitude,
  };

  const region = {
    ...coordinate,
    // Arbitrary distance that looks nice
    latitudeDelta: 0.0015,
    longitudeDelta: 0.0015,
  };

  return (
    <View
      style={[
        styles.container,
        isSmallLayout ? styles.smallHeight : styles.largeHeight,
      ]}
    >
      <StaticMapView initialRegion={region}>
        <MapMarker coordinate={coordinate} />
      </StaticMapView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    height: Dimensions.get('window').height / 4,
  },
  largeHeight: {
    maxHeight: 400,
  },
  smallHeight: {
    maxHeight: 210,
  },
});
